import Vue from 'vue';
import VueSearchLocator from '@cherrypulp/vue-search-locator';

export default {
	when() {
		return document.querySelectorAll('.search-locator').length > 0;
	},
	mounted() {
		Vue.use(VueSearchLocator, {
			key: 'AIzaSyA9Q7Un8mToWsjXcaY9g1DJ6o2vRI3wxu0',
		});

		new Vue({
			data() {
				return {
					distributors: window.__app.distributors,
				};
			},
		}).$mount('#app');
	},
};